import { useUser } from '@teetsh/app/src/containers/App/context/useUser';

export function useCountryConfig() {
  const user = useUser();
  const hasFrenchScholarSystem = user.scholarSystem === 'FR';
  const isFrenchLocale = /^fr/.test(user.locale);

  return {
    isFieldIneEnabled: hasFrenchScholarSystem,
    isFeatureIAEnabled: ['fr-FR', 'fr-BE'].includes(user.locale),
    isMenuItemLsuEnabled: hasFrenchScholarSystem,
    areOnboardingTutoEnabled: isFrenchLocale,
    isIllustrationEnabled: isFrenchLocale,
    isImportFileFirstStepEnabled: hasFrenchScholarSystem,
    isPlannerView108hEnabled: hasFrenchScholarSystem,
  };
}
